<template>
  <b-container class="landingPageCategorySection--landing">
    <b-row class="title--category-section">
      {{ section.title }}
    </b-row>
    <b-row class="sectionMainContainer">
      <b-row class="sectionContainer">
        <LandingPageCategoryProduct
          v-for="sectionProduct in sectionProducts"
          :key="sectionProduct._id"
          :product="sectionProduct.product"
        />
      </b-row>
    </b-row>
  </b-container>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import LandingPageCategoryProduct from '@/components/Front/landing/LandingPageCategoryProduct'

const landingPageCategoryProductStore = namespace(
  'landingPageCategoryProductStore'
)

@Component({
  components: {
    LandingPageCategoryProduct,
  },
})
export default class LandingPageCategorySection extends Vue {
  @Prop({ type: Object, required: true, default: null }) section

  @landingPageCategoryProductStore.Action('fetchItems') actionFetchProductList
  @landingPageCategoryProductStore.Getter('publishedProductsBySection')
  sectionProductsGetter

  created() {
    this.actionFetchProductList(this.section._id)
  }

  get sectionProducts() {
    return this.sectionProductsGetter(this.section._id)
  }
}
</script>

<style>
.landingPageCategorySection--landing {
  max-width: 1280px;
}
.title--category-section {
  border-bottom: solid 3px black;
  color: #202020;
  font-weight: bold;
  font-size: 2.25rem;
  letter-spacing: 2px;
  line-height: 38px;
  margin-bottom: 15px;
  margin-top: 30px;
  padding-bottom: 15px;
  text-transform: uppercase;
}
.sectionMainContainer {
  margin: auto;
}
@media (max-width: 1317px) {
  .sectionMainContainer {
    max-width: 922px;
  }
}
@media (max-width: 991px) {
  .sectionMainContainer {
    max-width: 596px;
  }
}
@media (max-width: 665px) {
  .sectionMainContainer {
    max-width: 269px;
  }
}
.sectionMainContainer .sectionContainer {
  margin-left: -28px;
  margin-right: -28px;
}
</style>
